// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ToggleFinalizeForHomeownerMutationVariables = Types.Exact<{
  optionId: Types.Scalars['ID']['input'];
  status: Types.HomeownerSelectionStatus;
}>;


export type ToggleFinalizeForHomeownerMutation = { __typename?: 'Mutation', makeHomeownerSelection: { __typename?: 'MakeHomeownerSelectionResult', homeownerSelectionOption: { __typename?: 'HomeownerSelectionOption', id: string, homeownerSelection: { __typename?: 'HomeownerSelection', id: string, status: { __typename?: 'HomeownerSelectionStatusDetail', code: Types.HomeownerSelectionStatus, name: string }, selectedOption?: { __typename?: 'HomeownerSelectionOption', id: string, canEditPrice: { __typename?: 'PotentialOperation2', allowed: boolean } } | null | undefined, options: Array<{ __typename?: 'HomeownerSelectionOption', id: string, isSelectedOption: boolean }>, changeEventLineItem?: { __typename?: 'ChangeEventLineItem', id: string, changeEvent: { __typename?: 'ChangeEvent', id: string, canCreateFinalEstimate: boolean } } | null | undefined } } } };


export const ToggleFinalizeForHomeownerDocument = gql`
    mutation ToggleFinalizeForHomeowner($optionId: ID!, $status: HomeownerSelectionStatus!) {
  makeHomeownerSelection(
    input: {homeownerSelectionOptionId: $optionId, homeownerSelectionStatus: $status}
  ) {
    homeownerSelectionOption {
      id
      homeownerSelection {
        id
        status {
          code
          name
        }
        selectedOption {
          id
          canEditPrice {
            allowed
          }
        }
        options {
          id
          isSelectedOption
        }
        changeEventLineItem {
          id
          changeEvent {
            id
            canCreateFinalEstimate
          }
        }
      }
    }
  }
}
    `;
export type ToggleFinalizeForHomeownerMutationFn = Apollo.MutationFunction<ToggleFinalizeForHomeownerMutation, ToggleFinalizeForHomeownerMutationVariables>;

/**
 * __useToggleFinalizeForHomeownerMutation__
 *
 * To run a mutation, you first call `useToggleFinalizeForHomeownerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleFinalizeForHomeownerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleFinalizeForHomeownerMutation, { data, loading, error }] = useToggleFinalizeForHomeownerMutation({
 *   variables: {
 *      optionId: // value for 'optionId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useToggleFinalizeForHomeownerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ToggleFinalizeForHomeownerMutation, ToggleFinalizeForHomeownerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ToggleFinalizeForHomeownerMutation, ToggleFinalizeForHomeownerMutationVariables>(ToggleFinalizeForHomeownerDocument, options);
      }
export type ToggleFinalizeForHomeownerMutationHookResult = ReturnType<typeof useToggleFinalizeForHomeownerMutation>;
export type ToggleFinalizeForHomeownerMutationResult = Apollo.MutationResult<ToggleFinalizeForHomeownerMutation>;
export type ToggleFinalizeForHomeownerMutationOptions = Apollo.BaseMutationOptions<ToggleFinalizeForHomeownerMutation, ToggleFinalizeForHomeownerMutationVariables>;